<template>
        <div>
                <div class='container'>
                    <transition name="fade">
                        <div v-if="performingRequest" class="loading">
                            <p>Sending Message...</p>
                        </div>
                    </transition>
                </div>
        </div>

</template>

<script>

/*module.exports = {
  props: ['receiverId']
}*/

    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

export default {
    props: ['breweryId'],

            data() {
            return {
                performingRequest: false,
                communicationRating:'',
                deliveryRating:'',
                overallRating:'',
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods:{
                postReview(){
            }
        },
}


</script>

<style>



</style>